import { render } from "./Mask.vue?vue&type=template&id=44f43be6&scoped=true"
import script from "./Mask.vue?vue&type=script&lang=js"
export * from "./Mask.vue?vue&type=script&lang=js"

import "./Mask.vue?vue&type=style&index=0&id=44f43be6&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-44f43be6"

export default script